import Triangle from './symbol/Triangle';
import StarFilled from './symbol/StarFilled';
import StarBorderd from './symbol/StarBordered';
import Receipt from './symbol/Receipt';
import describeArc from '../../lib/describeArc';

function ServiceProvider({
  serviceProvider,
  onClickHandler,
  index,
  id,
  map,
  theme,
  spAddress,
  contact,
}) {
  const radius = 20;
  const strokeWidth = 4;
  const viewBoxSize = radius * 2 + strokeWidth * 2;

  const arcs = [
    {
      startAngle: 0,
      endAngle: 90,
      value: contact?.servicesBrand || false,
    },
    {
      startAngle: 90,
      endAngle: 180,
      value: contact?.servicesIndustry || false,
    },
    {
      startAngle: 180,
      endAngle: 270,
      value: !(serviceProvider?.dispatchEvent?.status === 'REJECTED') || false,
    },
    {
      startAngle: 270,
      endAngle: 0,
      value: contact?.servicesProductLine || false,
    },
  ];

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('id', id);
  svg.setAttribute('data-index', index);
  svg.setAttribute('class', `map_clickable`);
  svg.setAttribute('width', viewBoxSize);
  svg.setAttribute('height', viewBoxSize);
  svg.setAttribute('viewBox', `0 0 ${viewBoxSize} ${viewBoxSize}`);

  const outerCircle = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'circle',
  );

  outerCircle.setAttribute('cx', viewBoxSize / 2);
  outerCircle.setAttribute('cy', viewBoxSize / 2);
  outerCircle.setAttribute('r', radius);
  outerCircle.setAttribute('stroke', theme.palette.warning.main); // '#90cee3'
  outerCircle.setAttribute('stroke-width', strokeWidth);
  outerCircle.setAttribute('id', 'outer');
  outerCircle.setAttribute('display', 'none');

  svg.appendChild(outerCircle);

  const innerCircle = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'circle',
  );

  innerCircle.setAttribute('cx', viewBoxSize / 2);
  innerCircle.setAttribute('cy', viewBoxSize / 2);
  innerCircle.setAttribute('r', radius - strokeWidth);
  innerCircle.setAttribute('fill', 'white');
  innerCircle.setAttribute('stroke', '#dedede');
  innerCircle.setAttribute('stroke-width', strokeWidth);

  svg.appendChild(innerCircle);

  arcs.forEach(item => {
    if (item.value) {
      const d = describeArc(
        viewBoxSize / 2,
        viewBoxSize / 2,
        radius - strokeWidth,
        item.startAngle,
        item.endAngle,
      );
      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path',
      );
      path.setAttribute('d', d);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', '#009ACD');
      path.setAttribute('stroke-width', strokeWidth);
      svg.appendChild(path);
    }
  });

  if (serviceProvider?.status !== 'ACTIVE') {
    svg.appendChild(Triangle(theme));
  } else if (
    serviceProvider?.nonCompliant ||
    serviceProvider.dispatchEvent?.status === 'REJECTED'
  ) {
    svg.appendChild(Receipt(theme));
  } else if (
    serviceProvider.dispatchEvent?.status === 'ACCEPTED_WITH_CONDITIONS'
  ) {
    svg.appendChild(StarFilled(theme));
  } else if (serviceProvider.dispatchEvent) {
    svg.appendChild(StarBorderd(theme));
  }

  const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  text.setAttribute('fill', '#000000');
  text.setAttribute('font-weight', '500');
  text.setAttribute('x', 24);
  text.setAttribute('y', 27);

  const textNode = document.createTextNode((index + 1).toString());
  text.appendChild(textNode);

  svg.appendChild(text);

  svg.addEventListener('click', e => {
    onClickHandler(e, map, serviceProvider.id, svg, spAddress);
  });

  return svg;
}

export default ServiceProvider;
